import { render, staticRenderFns } from "./CohortAddAccount.vue?vue&type=template&id=e0aba6d0&"
import script from "./CohortAddAccount.vue?vue&type=script&lang=js&"
export * from "./CohortAddAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports